/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SeizableIncomeCalculationResponse
 */
export interface SeizableIncomeCalculationResponse {
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeCalculationResponse
     */
    seizableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeCalculationResponse
     */
    standardSeizableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeCalculationResponse
     */
    maintenanceAdditionalAmount: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeCalculationResponse
     */
    retainedAmount: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeCalculationResponse
     */
    baseAmount: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeCalculationResponse
     */
    maxAssessment: number;
    /**
     * 
     * @type {boolean}
     * @memberof SeizableIncomeCalculationResponse
     */
    parametersAvailable: boolean;
}

/**
 * Check if a given object implements the SeizableIncomeCalculationResponse interface.
 */
export function instanceOfSeizableIncomeCalculationResponse(value: object): value is SeizableIncomeCalculationResponse {
    if (!('seizableAmount' in value) || value['seizableAmount'] === undefined) return false;
    if (!('standardSeizableAmount' in value) || value['standardSeizableAmount'] === undefined) return false;
    if (!('maintenanceAdditionalAmount' in value) || value['maintenanceAdditionalAmount'] === undefined) return false;
    if (!('retainedAmount' in value) || value['retainedAmount'] === undefined) return false;
    if (!('baseAmount' in value) || value['baseAmount'] === undefined) return false;
    if (!('maxAssessment' in value) || value['maxAssessment'] === undefined) return false;
    if (!('parametersAvailable' in value) || value['parametersAvailable'] === undefined) return false;
    return true;
}

export function SeizableIncomeCalculationResponseFromJSON(json: any): SeizableIncomeCalculationResponse {
    return SeizableIncomeCalculationResponseFromJSONTyped(json, false);
}

export function SeizableIncomeCalculationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeizableIncomeCalculationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'seizableAmount': json['seizableAmount'],
        'standardSeizableAmount': json['standardSeizableAmount'],
        'maintenanceAdditionalAmount': json['maintenanceAdditionalAmount'],
        'retainedAmount': json['retainedAmount'],
        'baseAmount': json['baseAmount'],
        'maxAssessment': json['maxAssessment'],
        'parametersAvailable': json['parametersAvailable'],
    };
}

export function SeizableIncomeCalculationResponseToJSON(json: any): SeizableIncomeCalculationResponse {
    return SeizableIncomeCalculationResponseToJSONTyped(json, false);
}

export function SeizableIncomeCalculationResponseToJSONTyped(value?: SeizableIncomeCalculationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'seizableAmount': value['seizableAmount'],
        'standardSeizableAmount': value['standardSeizableAmount'],
        'maintenanceAdditionalAmount': value['maintenanceAdditionalAmount'],
        'retainedAmount': value['retainedAmount'],
        'baseAmount': value['baseAmount'],
        'maxAssessment': value['maxAssessment'],
        'parametersAvailable': value['parametersAvailable'],
    };
}

